(function($) {

	$('.mobile.nav-toggle p').click(function() {
		event.stopPropagation();
	})

	$('.mobile.nav-toggle').click(function() {
		if ($('.sidebar-nav').is(':hidden')) {
			$('.mobile.nav-toggle h3 span').html('Close');
			$('.sidebar-nav').slideDown('fast');
			$('.mobile.nav-toggle h3 .fa').removeClass('fa-chevron-down').addClass('fa-chevron-up');
		}
		else {
			$('.mobile.nav-toggle h3 span').html('Browse');
			$('.sidebar-nav').slideUp('fast');
			$('.mobile.nav-toggle h3 .fa').removeClass('fa-chevron-up').addClass('fa-chevron-down');
		}
	});

	$(window).on('resize', function() {
		if ($(window).innerWidth() > 768 && $('.sidebar-nav:not(.browse-legacy)').is(':hidden')) {
			$('.sidebar-nav:not(.browse-legacy)').show();
		}
	})

	// Extra Links
	$('.extraLinks-button').click(function() {
		const button = this;
		const isExpanded = button.getAttribute('aria-expanded') === 'true';
		button.setAttribute('aria-expanded', !isExpanded);
		$(".extraLinks-body").attr('aria-hidden', isExpanded);
		$(".extraLinks").toggleClass('active');
	});
	// keyboard access
	$('.extraLinks-button').on('keydown', function(event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			$(this).click();
		}
	});
	$(document).on('click', function(event) {
		if ($('.extraLinks').hasClass('active') && !$(event.target).closest('.extraLinks').length) {
			$('.extraLinks-button').click();
		}
	});
	// when click on '.alert-status-button', and the extraLinks is open, close it
	$('.alert-status-button').on('click', function() {
		if ($('.extraLinks').hasClass('active')) {
			$('.extraLinks-button').click();
		}
	});
})(jQuery);
